import { Row } from "@tanstack/react-table";

import { Button } from "@/components/ui/button/button";

import { useViewLeadLogs } from "../view-lead-logs/use-view-lead-logs";
import { Lead } from "./schema";

interface DataTableRowActionsProps<TData> {
  row: Row<TData>;
}

// @ts-ignore
export function DataTableRowActions<TData>({
  row,
}: DataTableRowActionsProps<TData>) {
  const originData = row.original as Lead;

  const { setLeadId, onOpenChange } = useViewLeadLogs();

  return (
    <>
      <Button
        size="sm"
        variant="outline"
        onClick={() => {
          setLeadId(originData?.id);
          onOpenChange(true);
        }}
      >
        View log
      </Button>
    </>
  );
}
